/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowBoldUp: {
  name: 'arrow-bold-up';
  data: string;
} = {
  name: 'arrow-bold-up',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 .5a.5.5 0 0 1 .384.18l5 6A.5.5 0 0 1 13 7.5h-2.5V14A1.5 1.5 0 0 1 9 15.5H7A1.5 1.5 0 0 1 5.5 14V7.5H3a.5.5 0 0 1-.384-.82l5-6A.5.5 0 0 1 8 .5Zm-3.932 6H6a.5.5 0 0 1 .5.5v7a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V7a.5.5 0 0 1 .5-.5h1.932L8 1.781 4.068 6.5Z" fill="currentColor"/></svg>`,
};
